import { render, staticRenderFns } from "./card-address.vue?vue&type=template&id=e60cf630&scoped=true"
import script from "./card-address.vue?vue&type=script&lang=js"
export * from "./card-address.vue?vue&type=script&lang=js"
import style0 from "./card-address.vue?vue&type=style&index=0&id=e60cf630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60cf630",
  null
  
)

export default component.exports